<!-- Con <base href="/"> un href="#..." verrebbe risolto come "/#...": cambierebbe pagina.
     Il click viene quindi gestito in locale: si sposta il focus su <main> senza navigare. -->
<a class="skip-link" href="#contenuto-principale" (click)="skipToMain($event)">Salta al contenuto principale</a>
<app-spinner></app-spinner>
<app-header></app-header>
<app-notification></app-notification>
<main id="contenuto-principale" tabindex="-1">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
